<div class="action-arrow__content">
	<a class="action-icon action-icon-active" (click)="onEditProducts()" title="Edit Product">
		<i class="fas fa-edit active"></i>
	</a>
	<a class="action-icon action-icon-active" (click)="onCloneProducts()" title="Clone Product">
		<i class="fas fa-clone active"></i>
	</a>
</div>